import * as types from "./ActionTypes";
import Api from "../api/AuthenticationApi";

export const selectUser = (value) => {
    return { type: types.SELECT_USER, user: value };
};

export const selectProduct = (value) => {
    return { type: types.SELECT_PRODUCT, product: value };
};

export const impersonateUser = (userId, productName) => {
    return (dispatch) => {
        return Api.impersonateUser(userId, productName)
            .then((data) => {
                dispatch({ type: types.IMPERSONATION_SUCCEEDED, url: data.Url });
            })
            .catch((error) => {
                dispatch({ type: types.IMPERSONATION_FAILED, error });
                throw(error);
            });
    };
};

export const accessSite = (userId, productId, returnUrl) => {
    return (dispatch) => {
        return Api.accessSite(userId, productId, returnUrl)
            .then((redirectUrl) => {
                dispatch({ type: types.IMPERSONATION_SUCCEEDED, url: redirectUrl });
            })
            .catch((error) => {
                dispatch({ type: types.IMPERSONATION_FAILED, error });
                throw(error);
            });
    };
};

export const loginToSisense = (orgid, virtualUserId) => {
    return (dispatch) => {
        return Api.loginToSisense(orgid, virtualUserId)
            .then((data) => {
                dispatch({ type: types.LOGIN_TO_SISENSE_SUCCEEDED, url: data });
            })
            .catch((error) => {
                dispatch({ type: types.LOGIN_TO_SISENSE_FAILED, error });
                throw(error);
            });
    };
};
